import { useTranslation } from 'libs/i18n';
import { Pressed, Stack, Typography } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { FormContent } from 'modules/auth/login/components/VerificationCodeForm/FormContent';

interface Props {
  onBackPassword?: () => void;
}

export const TwoFactorAuthentication = ({ onBackPassword }: Props) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={24}>
      <Pressed>
        <Stack
          alignItems="center"
          direction="row"
          spacing={4}
          onClick={onBackPassword}
        >
          <Icon.Left size={16} />
          <Typography variant="captionMedium">{t('common.back')}</Typography>
        </Stack>
      </Pressed>
      <Stack as="header" spacing={16}>
        <Typography as="h1" variant="header">
          {t('auth.login.twoFactorAuthentication.title')}
        </Typography>
        <Typography variant="bodyMedium">
          {t('auth.login.twoFactorAuthentication.subtitle')}
        </Typography>
      </Stack>
      <FormContent fieldName="otpCode" />
    </Stack>
  );
};
